import styled from 'styled-components';

export const MainMenuLinksGrid = styled.div(
  ({
    theme: {
      conditions: { tablet },
    },
  }) => ({
    display: 'grid',
    gridTemplateColumns: 'repeat(1, 1fr)',
    gap: 15,

    [tablet]: {
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: 20,
    },
  })
);
